import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  label: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg' : 'px-6 py-4 text-sm sm:text-base';
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('InitiateCheckout', {
    value: 27,
    currency: 'USD'
  })} className={`group inline-flex w-full items-center justify-center gap-3 rounded-full bg-lime-500 font-extrabold uppercase tracking-wide text-ink-950 shadow-glow transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-lime-400 active:translate-y-0 sm:w-auto ${sizing} ${className}`} style={{
    width: "330px",
    height: "40px"
  }} data-id="element-65" data-mp="qir0vgdncusn">
      <span className="text-center leading-tight" style={{
      fontFamily: "Cabin, sans-serif"
    }} data-id="element-66" data-mp="157n32wt0vdlc">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-67" data-mp="39yrgxlaii6mp" />
    </a>;
}